import React, { Component } from "react";
import { connect } from "react-redux";

import { signIn } from "../../../actions/authActions";
import { RESPONSE_STATUS } from "../../../utils/constants";
import * as util from "../../../utils/util";
import { answerBubbleStyle, answerBubbleStyleMobile } from "../../utils/styles";
import { QuestionComponent, QuestionComponentButton } from "./OnboardingStyles";
import "./Account.css"

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountExist: false,
      emailInvalid: false,
      phoneInvalid: false,
      submitted: false,
      errorMessage: "",
      accountOptIn: false,
      accountOptIn2:false,
      email: "",
      firstName: "",
      lastName: "",
      birthDate: "",
      isShowAlertAge:false,
    };
  }

  componentWillMount() {
    if (window.location.pathname.includes("/ath"))
      this.setState({ accountOptIn: true,accountOptIn2: true});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated) {
      this.props.triggerNextStep();
    }
  }

  handleChange = e => {
    let output = e.target.value;
    let phoneOutput;
    if (e.target.name === "phoneNumber") {
      let input = output;
      input = input.replace(/[^0-9]/g, "");

      let area = input.substr(0, 3);
      let pre = input.substr(3, 3);
      let last = input.substr(6, 4);

      if (area.length < 3) {
        phoneOutput = "(" + area;
      } else if (area.length === 3 && pre.length < 3) {
        phoneOutput = "(" + area + ") " + pre;
      } else if (area.length === 3 && pre.length === 3) {
        phoneOutput = "(" + area + ") " + pre + "-" + last;
      }

      this.setState({ [e.target.name]: phoneOutput });
      return;
    }

    this.setState({ [e.target.name]: output });
  };

  handleTimeInputFocus = () =>{
    var birDom = document.getElementById("birthDate");
    birDom.focus();
    birDom.click();
  }

  handleDateFocus = () =>{
    var birDom = document.getElementById("birthDate");
    birDom.type = "date"
  }

  setBirtDate = (e) =>{
      this.setState({
        birthDate: e.target.value
      },()=>{
        this.verificationBirthDate(this.state.birthDate);
      })
  }

  handleEmailInputComplete = () => {
    const email = this.state.email;
    if (email) {
      fetch("/api/account/status?email=" + email)
        .then(response => response.text())
        .then(status => {
          this.setState({
            accountExist: status === "true",
            emailInvalid: false
          });
        });
    }
  };

  handleEmailInputCompleteAth = () => {
    const email = this.state.email;
    const url = "/api/ath/users/exist?email=" + email;
    if (email && email !== "") {
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then(response => {
        if (response.status >= 400 && response.status < 500)
          this.setState({ accountExist: false, emailInvalid: false });
        else if (response.status >= 200 && response.status < 300)
          this.setState({
            accountExists: true,
            errorMessage: "Account already exists."
          });
      });
    }
  };

  handleKeyPressed(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.handleSubmit(e);
    }
  }

  handleKeyDown(e) {
    let key = e.keyCode;
    if (key === 8) {
      let output = e.target.value;
      if (output.slice(-1) === " ") {
        output = output.substring(0, output.length - 2);
      } else {
        output = output.substring(0, output.length - 1);
      }
      this.setState({ [e.target.name]: output });
    }
  }

  gtag_report_conversion_create_an_account(url) {
    let callback = function() {
      if (typeof url !== "undefined") {
        window.location = url;
      }
    };
    window.gtag("event", "conversion", {
      send_to: "AW-782420739/LOabCPiL74wBEIOWi_UC",
      event_callback: callback
    });
    return false;
  }

  verificationBirthDate(birthDate){
    if(util.getAge(birthDate)  < 13){
      this.setState({
        isShowAlertAge:true
      });
    }else{
      this.setState({
        isShowAlertAge:false
      });
    }

  }

  handleSkip(e){
    e.preventDefault();
    const { email, firstName, lastName,birthDate } = this.state;
    if(this.state.isShowAlertAge){
      return false;
    }
    
    this.setState({ submitted: true });
    if (window.location)
    this.props.triggerNextStep({value:email +":" +firstName +":" +lastName +":" +birthDate +":" + this.state.accountOptIn.toString() +":" + this.state.accountOptIn2.toString()+":skipType"  });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, firstName, lastName,birthDate } = this.state;
    if(this.state.isShowAlertAge){
      return false;
    }

    if (this.state.accountExist) {
      if (email) {
        alert("Email address already exists")
        // 如果邮箱存在就去登录，现在不登录了
        // this.props.signIn(email, password);
      }
    } else {
      if (email && firstName && lastName && birthDate) {
        const isValidEmail = util.isValidEmail(email);
        this.setState({
          emailInvalid: !isValidEmail,
        });
        if (!isValidEmail) {
          alert('Please enter a correct email address');
          return false;
        }
        if(!firstName){
          alert('Please enter firstName');
          return false;
        }

        if(!lastName){
          alert('Please enter lastName');
          return false;
        }

        if(!birthDate){
          alert('Please enter birthDate');
          return false;
        }


        this.setState({ submitted: true });

        //GA Tracking Account Creation
        try {
          //GA Tracking Account Creation
          if (window.dataLayer && window.dataLayer.push)
            window.dataLayer.push({ event: "Create_account" });
        } catch (error) {
          console.log(error);
        }

        // this.gtag_report_conversion_create_an_account();
        window.fbq("trackCustom", "RegisteredAfterOnboarding");
        //Removed CompleteRegistration 07/22/2019
        // window.fbq('track', 'CompleteRegistration');
        if (window.location)
          this.props.triggerNextStep({
            value:
              email +
              ":" +
              firstName +
              ":" +
              lastName +
              ":" +
              birthDate +
              ":" +
              this.state.accountOptIn.toString()+
              ":" + this.state.accountOptIn2.toString()+
              ":submitType"
          });
      }else{
        const isValidEmail = util.isValidEmail(email);
        if (!isValidEmail) {
          alert('Please enter a correct email address');
          return false;
        }
        if (!isValidEmail) {
          alert('Please enter a correct email address');
          return false;
        }
        if(!firstName){
          alert('Please enter firstName');
          return false;
        }

        if(!lastName){
          alert('Please enter lastName');
          return false;
        }

        if(!birthDate){
          alert('Please enter birthDate');
          return false;
        }
      }
    }
  }

  handleAccountOptIn = () => {
    this.setState({ accountOptIn: !this.state.accountOptIn });
  };

  handleAccountOptIn2= () => {
    this.setState({ accountOptIn2: !this.state.accountOptIn2 });
  };

  renderErrorMessage() {
    if (
      this.state.emailInvalid ||
      this.state.phoneInvalid ||
      (this.props.authFailed &&
        this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED) ||
      this.state.errorMessage.length > 0
    )
      return (
        <div className="error-message">
          {this.state.emailInvalid && <p>Invalid email. Please try again.</p>}
          {this.state.phoneInvalid && (
            <p>Invalid phone number. Please try again.</p>
          )}
          {this.props.authFailed &&
            this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED && (
              <p>
                Your account already exists! Please enter the correct password
                to access your profile.
              </p>
            )}
          {this.state.errorMessage}
        </div>
      );
    return null;
  }

  render() {
    if (this.state.submitted) {
      return (
        <div
          style={
            this.props.answerWidthCheck <= 812
              ? answerBubbleStyleMobile
              : answerBubbleStyle
          }
        >
          Account information submitted.
        </div>
      );
    }
    const emailFilled = this.state.email ? "filled" : "";
    const phoneFilled = this.state.phoneNumber ? "filled" : "";
    const passwordFilled = this.state.password ? "filled" : "";
    const accountOptInFilled = this.state.accountOptIn ? "action" : "";
    const accountOptInFilled2 = this.state.accountOptIn2 ? "action" : "";

    return (
      <div className="onboarding-account-wrapper">
        {this.renderErrorMessage()}
        <div className="account-info-container">
          <QuestionComponent className="container right mobil-input-zone">
            <div className="name-area">
              <div className={"question__responses textbox focus "}>
                <input type="text" name="firstName" placeholder="First Name" onChange={this.handleChange}></input>
              </div>

              <div className={"question__responses textbox focus "}>
                <input type="text" name="lastName" placeholder="Last Name" onChange={this.handleChange}></input>
              </div>
            </div>

            <div className={"question__responses textbox focus " + emailFilled}>
              <input
                type="text"
                name="email"
                placeholder="Email address"
                value={this.state.email}
                onChange={this.handleChange}
                onBlur={
                  window.location.pathname.includes("/ath")
                    ? this.handleEmailInputCompleteAth
                    : this.handleEmailInputComplete
                }
                onKeyPress={this.handleKeyPressed.bind(this)}
                onFocus={() => {
                  this.setState({ errorMessage: "" });
                }}
              />
            </div>
            
            <div className="select-dateBirth-zone">
              <div className="example-custom-border-style">
                <div className="birtValue-text" onClick={this.handleTimeInputFocus}>{this.state.birthDate ? this.state.birthDate:"Date of birth"}</div>
                <input type="date" className="example-custom-input" id="birthDate" onChange={date=>{ this.setBirtDate(date) }}></input>
              </div>
            </div>
            
          </QuestionComponent>
          {
            this.state.isShowAlertAge ? <div className="alertAccountAge-style">Apologies! You are unfortunately under age for this diagnosis. Age cannot be less than 13.</div> : null
          }
      </div>
        <div className="button-zone-s">
              <button className="sub-but-for" disabled = {this.state.isShowAlertAge ? 'disabled': null }   onClick={this.handleSubmit.bind(this)}>Submit</button>
              <a className="link-sk"  onClick={(e)=>{this.handleSkip(e)}}>skip</a>
        </div>


          <div className="account-checkbox-messaging-container">
            <label className="account-checkbox-messaging-checkbox-container">
              <input name="accountOptIn" type="checkbox" checked={this.state.accountOptIn} onChange={this.handleAccountOptIn}/>
              <span className={"account-checkbox-check " + accountOptInFilled}/>
            </label>
            <div className="account-checkbox-messaging">
              Keep me posted about exciting offers, products updates and more from All Things Hair. Learn more about our{" "}
              <a className="account__privacy-policy-link" target="_blank" href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html">Privacy Notice</a> .
            </div>
          </div>
            
          <div className="account-checkbox-messaging-container">
            <label className="account-checkbox-messaging-checkbox-container">
              <input name="accountOptIn2" type="checkbox" checked={this.state.accountOptIn2} onChange={()=>{this.handleAccountOptIn2()}}/>
              <span className={"account-checkbox-check " + accountOptInFilled2}/>
            </label>
              <div className="account-checkbox-messaging">
                Keep me posted about exciting offers, products updates and more from HelloAva. Learn more about their{" "}
                <a className="account__privacy-policy-link" target="_blank" href="https://www.unilevernotices.com/usa/english/privacy-notice/notice.html">Privacy Notice</a> .
              </div>
          </div>
        



      </div>
    );
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isFetching, isAuthenticated, authFailed, error } = helloava.auth;
  return { isFetching, isAuthenticated, authFailed, error };
}

function mapDispatchToProps(dispatch) {
  return {
    signIn: (email, password) => dispatch(signIn(email, password))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);



// WEBPACK FOOTER //
// ./src/ath/views/v1/Account.js